/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { Component } from '@appCanvasCommon/component-system/Component';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { CanvasAngularLand } from '../../../../app-data/interfaces/canvas-angular-land';
import { AbstractApplication } from '@appCanvasCommon/core/AbstractApplication';
import { IExportContext } from '@appCanvasCommon/export/IExportContext';
import { TicketPlanApplication } from '@appPlanApplication/TicketPlanApplication';
import { MilestoneLineDrawer } from '@appPlanApplication/timeline/milestone-line/MilestoneLineDrawer';
/**
 * This export component hides the root milestone node when the capture is printing the 2nd row and beyond
 * Otherwise the milestone line would be copied vertically as the camera scans the plan area.
 */
export class HideMilestoneLabel extends Component implements ComponentInterface {
	/**
	 * Invoked for each tile captured.
	 * @param canvasAngularLand
	 * @param application
	 * @param context
	 */
	public onExportTile(
		canvasAngularLand: CanvasAngularLand,
		application: AbstractApplication,
		context: IExportContext
	): void {
		if (context.isFirstRow) {
			return;
		}

		const app: TicketPlanApplication = application as TicketPlanApplication;
		const line: MilestoneLineDrawer = app?.timeline?.milestoneLine;
		if (line) {
			line.hideLabel();
			line.hideIcon();
		}
	}
	/**
	 * Invoked once the export is finished. This turns the milestone line back on.
	 * @param canvasAngularLand
	 * @param application
	 */
	public onExportComplete(canvasAngularLand: CanvasAngularLand, application: AbstractApplication): void {
		const app: TicketPlanApplication = application as TicketPlanApplication;
		const line: MilestoneLineDrawer = app?.timeline?.milestoneLine;
		if (line) {
			line.showLabel();
			line.showIcon();
		}
	}
}
